
<div class="time-picker-component">
  <form  class="dense-1" [formGroup]="pinform">
    <mat-form-field appearance="outline" fxFlex="15" fxFlex.xs="30" fxFlex.lt-md="40" fxLayoutGap="10px">
      <mat-select formControlName="ampm" (selectionChange)="onSelectionChange($event)">
        <mat-select-trigger>
          {{ getCountryCode(pinform.get('ampm').value) }}
        </mat-select-trigger>
        <mat-option>
          <ngx-mat-select-search placeholderLabel="Search"
          [formControl]="searchControl"></ngx-mat-select-search>
        </mat-option>
        @for (country of filteredCountries; track country) {
          <mat-option [value]="country.id">
            <img [src]="country.flag">&#160; {{country.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      &#160;

      <div fxLayout="column" fxFlex.xs="70" fxFlex.lt-md="60"  fxFlex fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline">
          <input 
            (input)="trimSpaces('endTimeHour'); changeValue('endTimeHour', pinform.value.endTimeHour)"
            matInput
            type="tel"
            placeholder="Enter Number"
            id="end_time_hour"
            formControlName="endTimeHour"
            (click)="preventMatSelectOpen($event)"
            (keyup)="errmsg($event)"
            />

          <!-- Required field error -->
          @if (pinform.get('endTimeHour').hasError('required') && pinform.get('endTimeHour').touched) {
            <mat-error>
              This field is required
            </mat-error>
          }

          <!-- Invalid number length error -->
          @if (pinform.get('endTimeHour').hasError('customError')) {
            <mat-error>
              Please Enter a Valid Number
            </mat-error>
          }
        </mat-form-field>

      </div>
    </form>
  </div>


